import actions from './splitIO_actions';

export const clearSplitIOTreatments = () => {
  return { type: actions.clearSplitIOTreatments };
};

const INITIAL_STATE = {
  treatments: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.getSplitIOTreatments:
      return {
        ...state,
        treatments: { ...state.treatments, ...action.treatment },
      };
    case actions.clearSplitIOTreatments:
      return { state, treatments: {} };
    default:
      return { ...state };
  }
}
